const MainIntro = () => {
	const block = document.querySelector(".main-intro");
	if (!block) {
		return;
	}

	const image = block.querySelector(".main-intro__image");
	const title = block.querySelector(".main-intro__title");
	
	if (image && title) {
		const clonedImage = image.cloneNode(true);
		
		clonedImage.classList.add('main-intro__image_cloned');
		clonedImage.querySelector('.main-intro__image-i').setAttribute('loading', 'lazy');
		
		title.insertAdjacentElement('afterend', clonedImage);
	}
};

export default MainIntro;
